{
    "DataTable_AreYouSure": "Möchten Sie Folgendes wirklich löschen? \n \n **{}**",
    "NAME": "LanguageDataTable"
}